import type { SectionType } from "./types";
import type { ISelectItem } from "../../types/common";

export const CLIENT_ROUTE = '/sections';
export const API_ROUTE = '/api/section'
export const CLIENT_TITLE = 'Нүүр хуудас бүлэг'
interface ISectionTypeItem extends ISelectItem {
    value: SectionType;
}

export const sectionTypes: ISectionTypeItem[] = [
    { value: 'category', label: 'Категори' },
    { value: 'groupNumber', label: 'Бүлгийн дугаар' },
    { value: 'playlist', label: 'Playlist' },
]